(function(){
 'use strict';


 if (!theme.storeSelectorData) {
   return;
 }


 const wasLandingStoreSelectorShown = Cookies.get('landing-store-selector');
 const storeSelectorTriggers = document.querySelectorAll('.store-selector__trigger');
 const storeSelectorModal = document.querySelector('.store-selector__modal');
 if (!storeSelectorTriggers && storeSelectorTriggers.length === 0) {
   return;
 }


 storeSelectorTriggers.forEach((trigger) => {
   trigger.addEventListener('click', (e) => {
     e.preventDefault();
     storeSelectorModal.classList.add('store-selector__modal--open');
   });
 });


 function closeStoreSelectorModal() {
   storeSelectorModal.classList.remove('store-selector__modal--open');
 }


 storeSelectorModal.addEventListener('click', (e) => {
   e.preventDefault();
   e.stopPropagation();
 });


 storeSelectorModal.querySelector('.store-selector__close').addEventListener('click', closeStoreSelectorModal);


 // modal elements
 const $storeSelectorHeadline = storeSelectorModal.querySelector('.store-selector__modal__title');
 const $storeSelectorSelectorLabel = storeSelectorModal.querySelector('.store-selector__selector-label');
 const $storeSelectorDescription = storeSelectorModal.querySelector('.store-selector__description-text');
 const $storeSelectorCurrencyLabel = storeSelectorModal.querySelector('.store-selector__currency-label');
 const $storeSelectorChangeStoreButton = storeSelectorModal.querySelector('.store-selector__change-store-button');
  const $storeSelectorPaymentMethodsInternational = storeSelectorModal.querySelector('.store-selector__payment-methods-international');
 const $storeSelectorPaymentMethodsSwedish = storeSelectorModal.querySelector('.store-selector__payment-methods-swedish');
  const storeSelectorSelect = storeSelectorModal.querySelector('.store-selector__select');
 const storeLanguageSelectNl = storeSelectorModal.querySelector('.store-selector__language-select.nl-language');
 const storeLanguageSelectDe = storeSelectorModal.querySelector('.store-selector__language-select.de-language');
 const storeLanguageSelectIt = storeSelectorModal.querySelector('.store-selector__language-select.it-language');


 const storesMap = {
   'se': 'https://sweedbeauty.se/',
   'de': 'https://sweedbeauty.com/de-de',
   'en-de': 'https://sweedbeauty.com/en-de',
   'gb': 'https://sweedbeauty.com/en-gb',
   'nl': 'https://sweedbeauty.com/nl-nl',
   'en-nl': 'https://sweedbeauty.com/en-nl',
   'ax': 'https://sweedbeauty.com/en-eu',
   'us': 'https://sweedbeauty.com/',
   'it': 'https://sweedbeauty.com/it-it',
   'en-it': 'https://sweedbeauty.com/en-it',
 };


 let selectedStore = storeSelectorSelect.value;


 // change language, currency, store and flags on select change
 storeSelectorSelect.addEventListener('change', (e) => {
   selectedStore = e.target.value;
   const storeData = theme.storeSelectorData.dictionaries.find((dictionary) => {
     return dictionary.id.toLowerCase() === selectedStore;
   });


   if (!storeData) {
     return;
   }


   // change language
   $storeSelectorHeadline.textContent = storeData.headline;
   $storeSelectorSelectorLabel.textContent = storeData.selectLabel;
   $storeSelectorDescription.innerHTML = storeData.description.replace(/\n/g, "<br />");
   $storeSelectorCurrencyLabel.textContent = storeData.currencyLabel;
   $storeSelectorChangeStoreButton.textContent = storeData.changeStoreButton;


   // toggle payment methods
   $storeSelectorPaymentMethodsInternational.classList.toggle('hide', selectedStore === 'se');
   $storeSelectorPaymentMethodsSwedish.classList.toggle('hide', selectedStore !== 'se');


   storeLanguageSelectNl.classList.toggle('hide', selectedStore !== 'nl');
   storeLanguageSelectDe.classList.toggle('hide', selectedStore !== 'de');
   storeLanguageSelectIt.classList.toggle('hide', selectedStore !== 'it');


   console.log(storeData);
 });


 $storeSelectorChangeStoreButton.addEventListener('click', () => {
   const storesWithLanguage = ['de', 'nl', 'it'];
   let storeKey = selectedStore;
   if (storesWithLanguage.includes(selectedStore)) {
     const activeLanguageSelect = storeSelectorModal.querySelector('.store-selector__language-select:not(.hide)');
    
     if (activeLanguageSelect?.value !== selectedStore) {
       storeKey = `${activeLanguageSelect.value}-${selectedStore}`;
     }
   }


   if (window.__isLandingStoreSelectorEnabled) {
     Cookies.set('landing-store-selector', true, { expires: 365 });
   }
   Cookies.set('selected-store-selector', selectedStore, { expires: 365 });


   // console.log('store url is', storeKey, storesMap[storeKey]);
    window.location.href = storesMap[storeKey]
 });




 // If window.__isLandingStoreSelectorEnabled is true, we append the landing layer "#store-selector__landing-layer__template" to the body
 if (window.__isLandingStoreSelectorEnabled && !wasLandingStoreSelectorShown) {
   storeSelectorModal.classList.add('store-selector__modal--open', 'store-selector__landing-layer');
 }


 window.geoip = function(json) {
   const geoCountryCode = json?.country_code?.toLowerCase();
   const storeCountry = Shopify?.country?.toLowerCase();


   if (!geoCountryCode || !storeCountry) {
     return;
   }


   if (geoCountryCode !== storeCountry) {
     const cookieSelectedStore = Cookies.get('selected-store-selector');
       if (cookieSelectedStore === 'ax') {
       return;
     }
     if (cookieSelectedStore !== storeCountry) {
       storeSelectorModal.classList.add('store-selector__modal--open');
     }
   }
 }


 var tag = document.createElement('script');
 tag.src = "https://get.geojs.io/v1/ip/geo.js";
 tag.setAttribute('async', '');
 var firstScriptTag = document.getElementsByTagName('script')[0];
 firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
})();

